/**
 * 기본 숨김(게이트 대상) 커스텀 폰트 family 집합. base 폰트가 아닌, 특정 고객에게만 노출하던
 * 폰트들이다. 종전에는 tenantId + CUSTOMER_FONT_TENANT_IDS 하드코딩으로 노출을 판정했으나,
 * 이제 space UI 프로파일 serve 의 resources.allowedFontIds(가시성 게이트)로 판정한다.
 * base 폰트는 이 집합에 없으므로 항상 노출된다.
 */
export const CUSTOMER_GATED_FONT_FAMILIES: readonly string[] = [
  'Sandoll Nemony2',
  'SDHoyoyo',
  'Fredoka',
];

/**
 * 커스텀 폰트 노출 여부.
 * - base 폰트(게이트 대상 아님): 항상 노출.
 * - 운영자: 게이트 우회 → 항상 노출.
 * - 게이트 폰트: space 의 allowedFontIds 에 포함될 때만 노출.
 * - allowedFontIds 미설정(null/undefined/빈 배열): 게이트 폰트는 숨김 =
 *   종전 "허용 목록 없음" 기본(base) 동작과 동일.
 */
export const canShowCustomerFont = ({
  fontFamily,
  allowedFontIds,
  isOperator,
}: {
  fontFamily: string;
  allowedFontIds: readonly string[] | null | undefined;
  isOperator: boolean;
}): boolean => {
  if (!CUSTOMER_GATED_FONT_FAMILIES.includes(fontFamily)) return true;
  if (isOperator) return true;
  return allowedFontIds?.includes(fontFamily) ?? false;
};
